<template>
  <div>
    <!-- 跟进 联系人-->
    <van-tabs v-model="activeName">
      <van-tab title="跟进记录" name="active_visit">
        <div class="concat-container">
          <div class="concat-header">
            <div class="title">
              共({{listVisit.length}})条
            </div>
            <span v-hasPermi="['scrm:visit:add']" class="add-title" @click="handleaddvisit"><van-icon color="#1989fa" name="add" size="22" /></span>
          </div>
          <div class="concat-list" v-if="listVisit.length > 0">
            <van-steps direction="vertical">
              <van-step  class="concat-item" v-for="visit in listVisit" :key="visit.visitId">
                 <div>
                    <span v-if="visit.boName" style="color:#2196f3">商机：{{visit.boName }}</span>
                    <span style="color:#191919;">回访内容： {{visit.content}}</span>
                    <span v-if="visit.contactName">{{visitTypeFormat(visit.visitType)}}&nbsp;&nbsp;[{{visit.contactName}}]</span>
                  </div>
                  <div class="content-footer ">
                    <span>{{visit.createTime}}</span>
                  </div>
              </van-step>
            </van-steps>
          </div>
          <empty v-else />
        </div>
      </van-tab>
      <!-- <van-tab title="商机" name="active_bo">
        <div class="concat-container">
          <div class="concat-header">
            <div class="title">
              共({{boList.length}})个商机
            </div>
            <span v-hasPermi="['scrm:bo:add']" class="add-title" @click="toAddBo"><van-icon color="#1989fa" name="add" size="15" /></span>
          </div>
          <div class="concat-list" v-if="boList.length > 0">
            <div class="concat-item" v-for="bo in boList" :key="bo.boId">
              <div class="content-header m-b-20">
                <div class="content-header_title">
                   <em class="boSty"><van-icon name="goods-collect"/></em><span>{{bo.boName}}</span>
                </div>
              </div>
              <div class="content-main m-b-20" style="clear:both;">
                <div style="float:left;width:100%">
                  <span style="width:100%">业务类型：{{bo.businessTypeName}}</span>
                  <span style="float:left;width:65px">可能性：</span>
                  <span class="value">{{formatHandel('possibility',bo.possibility)}}</span>
                  <span style="float:left;"><van-progress style="width:150%;margin-top: 3px;" stroke-width="8" :percentage="bo.possibility" /></span>
                </div>
                <span>负责人：{{bo.userName}}</span>
                <span>预期收益：{{bo.expectProfit}}</span>
                <span>商机状态：{{formatHandel('boStatus',bo.boStatus)}}</span>
                <span>商机来源：{{formatHandel('boSource',bo.boSource)}}</span>
                <span>分配状态：{{formatHandel('distributeStatus',bo.distributeStatus)}}</span>
                <span>意向度：{{formatHandel('possibility',bo.possibility)}}</span>
                <div style="float:left;width:100%">
                  <span style="float:left;width:65px">商机阶段：</span>
                  <span style="float:left;"><van-progress style="width:150%;margin-top: 3px;" :pivot-text="bo.stageName" stroke-width="8" :percentage="bo.stageValue" /></span>
                </div>
              </div>
            </div>
          </div>
          <empty v-else />
        </div>
      </van-tab> -->
      <van-tab title="联系人" name="active_contract">
        <div class="concat-container">
          <div class="concat-header">
            <div class="title">
              共({{custContactOptions.length}})位联系人
            </div>
            <span v-hasPermi="['scrm:contact:add']" class="add-title" @click="handleAddContacts"><van-icon color="#1989fa" name="add" size="22" /></span>
          </div>
          <div class="concat-list" v-if="custContactOptions.length > 0">
            <div class="concat-item" v-for="contact in custContactOptions" :key="contact.contactId">
              <div class="content-header m-b-20">
                <div class="content-header_title">
                  <em :class="contact.sex==1?'blue':contact.sex==2?'red':'gray'"><van-icon name="manager"/></em>
                  <span>{{contact.contactName}}</span>
                  <span>{{contact.mobile}}</span><van-icon name="phone-circle-o" color="#07c160" size="24" v-if="contact.mobile && contact.mobile.length > 6" @click="callPhone(contact.mobile)" />
                </div>
                <!-- <span>{{contact.mobile}}</span> -->
                <!-- <div>
                  <span v-if="custStatus !== '0'">
                    <van-icon name="edit" size="16" color="#1989fa" @click="editContract(contact.contactId)" v-hasPermi="['scrm:contact:edit']" />
                    <van-icon style=" padding-left:10px;padding-right:10px;" color="#ee0a24" name="close" size="16" @click="delContact(contact.contactId)" v-hasPermi="['scrm:contact:remove']" />
                  </span>
                </div> -->
              </div>
              <div class="content-main m-b-20" style="clear:both;">
                <!-- <span>性 别：{{contactSexFormat(contact.sex)}}</span> -->
                <!-- <span>姓名：{{contact.contactName}}</span>
                <span>性别：{{contactSexFormat(contact.sex)}}</span>
                <span>手机号：{{contact.mobile}}</span> -->
                <span>职务：{{contact.jobs}}</span>
                <span>微信号：{{contact.weixinSn || '-'}}</span>
                <!-- <span style="width: 100%;">邮箱：{{contact.email}}</span> -->
              </div>
            </div>
          </div>
          <empty v-else />
        </div>
      </van-tab>
      <van-tab title="操作日志" name="operation_log">
        <div class="item">
          <van-steps direction="vertical" :active="100">
            <van-step v-for="(item,index) in operationLog" :key="index">
              <span>{{item.content}}</span>
              <div style="margin-top: 5px">{{item.createTime}}</div>
            </van-step>
          </van-steps>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
// import { getContact } from '@/api/scrm/custcontact'
import { Tabs, Tab, Icon, Button, Toast } from 'vant'
import Empty from '@/components/common/Empty'
// import { addVisit } from '@/api/scrm/custvisit'
export default {
  name: 'ContTab',
  props: {
    id: [String, Number],
    listVisitData: [Array, null],
    custContactOptionsData: [Array, null],
    custStatusData: String,
    bolist: [Array, null],
    name: String,
    custObj: [Object, null],
    operationLog: [Array, null]
  },
  components: {
    Empty,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  watch: {
    listVisitData: {
      immediate: true,
      handler(val) {
        this.listVisit = !val ? {} : val
      }
    },
    custContactOptionsData: {
      immediate: true,
      handler(val) {
        this.custContactOptions = !val ? {} : val
      }
    },
    bolist: {
      immediate: true,
      handler(val) {
        this.boList = !val ? {} : val
      }
    },
    custStatusData: {
      immediate: true,
      handler(val) {
        this.custStatus = !val ? {} : val
      }
    },
    id: {
      immediate: true,
      handler(val) {
        this.custId = !val ? {} : val
      }
    },
    custObj: {
      immediate: true,
      handler(val) {
        this.customer = !val ? {} : val
      }
    },
    operationLog: {
      immediate: true,
      handler(val) {
        this.operationLog = !val ? {} : val
      }
    }
  },
  data() {
    return {
      custId: this.id,
      activeName: 'active_visit',
      listVisit: this.listVisitData,
      custContactOptions: this.custContactOptionsData,
      boList: this.bolist,
      custVisitTypeOptions: [],
      custStatus: this.custStatusData,
      customer: {},
      // operationLog: this.operationLog,
      // 添加修改联系人title
      contactTitle: '',
      // 添加联系记录
      contactForm: {
        contactId: null,
        contactName: null,
        custId: null,
        custName: null,
        sex: null,
        mobile: null,
        qq: null,
        email: null,
        weixinSn: null,
        deptName: null,
        jobs: null,
        age: null,
        birthday: null,
        ideType: null,
        ideTypeName: null,
        ideSn: null,
        jobTitle: null,
        nickName: null,
        roleRelation: null,
        roleRelationName: null,
        intimacy: null,
        intimacyName: null,
        hobby: null,
        myUserid: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: '0',
        delFlag: null,
        orderNum: null,
        remark: null
      },
      // 回访记录
      visitForm: {
        content: null,
        visitType: null,
        custId: null,
        custName: null,
        contactId: null,
        contactName: null
      },
      // 性别状态字典
      sexOptions: this.$store.state.dictOptions.sex || [],
      // 证件类型
      ideTypeOptions: [],
      // 角色关系
      roleRelationOptions: [],
      // 亲密程度
      intimacyOptions: [],
      addContactShow: false,
      dictOptions: {}
    }
  },
  created() {
    this.getDicts('crm_visit_type').then(res => {
      this.custVisitTypeOptions = res.data
    })
    this.getDicts('sys_user_sex').then(res => {
      this.sexOptions = res.data
    })
    // 商机来源
    this.getDicts('crm_bo_source').then(res => {
      this.dictOptions.boSourceOptions = this.setDictToInt(res)
    })
    // 商机状态
    this.getDicts('crm_bo_status').then(res => {
      this.dictOptions.boStatusOptions = this.setDictToInt(res)
    })
    // 分配状态
    this.getDicts('cms_distribute_status').then(res => {
      this.dictOptions.distributeStatusOptions = this.setDictToInt(res)
    })
    // 意向度
    this.getDicts('crm_bo_possibility ').then(res => {
      this.dictOptions.possibilityOptions = res.data
    })
  },
  mounted() {
  },
  methods: {
    // 性别
    contactSexFormat(sex) {
      return this.selectDictLabel(this.sexOptions, sex)
    },
    handleAddContacts() {
      this.$emit('handleAddContacts')
    },
    editContract(id) {
      // this.$emit('handleEditContract', id)
    },
    // 删除联系人
    delContact(contactId) {
      // this.$emit('delContact', contactId)
    },
    handleaddvisit() {
      this.$emit('handleaddvisit')
    },
    toAddBo() {
      // this.$router.push({
      //   path: '/scrm/custBo/add?custName',
      //   query: { custName: this.name, custId: this.id, custSource: this.custSource }
      // })
      console.log(this.customer)
      if (!this.customer.unitNature || !this.customer.custLevel || !this.customer.industryCode) {
        Toast.fail('请先完善客户信息')
        setTimeout(() => {
          this.$router.push('/scrm/myCust/modifyInfos?custId=' + this.customer.custId)
        }, 500)
        return
      }
      this.$emit('handleAddBo')
      // this.$router.push(`/scrm/custBo/add?custName=` + this.name + `&custId=` + this.id)
      // this.$router.push(`/scrm/myCust/addInfos?custType=`+this.form.custType+`&custName=`+this.form.custName+`&custTypeName=`+this.form.custTypeName);
    },
    // 调用拨号功能
    callPhone(phoneNumber) {
      // window.location.href = "tel://158xxxx1317";
      window.location.href = 'tel://' + phoneNumber
    },
    // 获取访问类型
    visitTypeFormat(visitType) {
      if (this.custVisitTypeOptions != null) {
        var visitName = this.selectDictLabel(this.custVisitTypeOptions, visitType)
        if (visitName != null && visitName != '') {
          return '[' + visitName + ']'
        }
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.dictOptions[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.concat-container {
  background-color: #fff;
  padding-bottom: 40px;
  .concat-header {
    padding: 20px;
    display: flex;
    flex-direction: inherit;
    justify-content: space-between;
    align-items: center;
    color: #1989fa;
    width: 90%;
    margin: 0 auto;
    .title {
      padding: 0;
      color: #666;
      font-size: 20px;
      font-weight: normal;
    }
    .add-title{
      max-width: 26%;
      color: #666;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .concat-list {
    overflow: scroll;
    .concat-item {
      border-bottom: 1px solid #eee;
      font-size: 26px;
      margin-left: 15px;
      margin-right: 15px;
      padding: 20px;
      // span:first-child {
      //   color: #000;
      // }
      span {
        color: #888;
        width: 100%;
        // display: block;
        margin: 0.1rem 0;
      }
      .content-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .content-header_title {
          width: 70%;
          display: flex;
          align-items: center;
          span {
            color: #000;
          }
          em{
            float: left;
            padding: 0.1rem 0.1rem 0 0;
          }
          .red{
            color: #f32d50;
          }
          .blue{
            color: #2d5bf3;
          }
          .gray{
            color: #50535c;
          }
          .boSty{
              float: left;
              padding: 0 0.1rem 0 0;
              font-size: 0.45rem;
              color:#108bed;
          }
        }

        .title {
          color: #ccc;
          font-size: 14px;
        }
      }
      .content-footer {
        margin-top: 20px;
        span {
          color: #888;
        }
      }
      span {
        font-size: 26px;
        word-break: break-all;
      }
    }
    .content-main {
      display: flex;
      flex-wrap: wrap;

      span {
        margin-bottom: 0.2rem;
        width: 48%;
        font-size: 26px;
        color: #888;
      }
    }
  }
}
.type_style {
  color: rgb(48, 153, 172);
}
.name_style {
  color: rgb(119, 150, 10);
}
.van-empty {
  background-color: #fff;
}
</style>
